module.exports = __webpack_public_path__ + "static/media/landingSwipeTwo.566c7abd.png";